import { Component } from '@angular/core';
import { TAX_ACCOUNTING_LABELS } from '../../../core/constants/taxAccounting.constants';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tax-accounting-header',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './tax-accounting-header.html',
  styleUrl: './tax-accounting-header.scss',
})
export class TaxAccountingHeader {
  headerLabels = TAX_ACCOUNTING_LABELS;
}
